import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowLeft from "../images/ArrowLeft.png";
import Share from "../images/Share.png";

const HeaderBar = ({ title, onShareClick, onSearchClick, showSearch = true, backPath }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);   
    } else {
      navigate(-1);        
    }
  };

  return (
    <div className="sticky top-0 bg-white z-30 border-b border-gray-200 px-1 flex items-center justify-between h-14">
      
      {/* Left Section */}
      <div className="flex items-center gap-1">
        <button
          onClick={handleBack}
          className="flex items-center justify-center"
        >
          <img
            src={ArrowLeft}
            alt="Back"
            className="w-12 h-8 object-contain"
          />
        </button>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      </div>

      {/* Right Section */}
      <div className="flex items-center mr-2">
        {showSearch && (
          <button
            onClick={onSearchClick}
            className="p-2 rounded-full transition ml-1 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M17 10.5A6.5 6.5 0 1 1 4 10.5a6.5 6.5 0 0 1 13 0z"
              />
            </svg>
          </button>
        )}

        <button
          onClick={onShareClick}
          className="flex items-center space-x-1 text-gray-900 px-2 py-1 rounded-md hover:brightness-0 hover:invert hover:opacity-100 transition"
        >
          <img
            src={Share}
            alt="Share"
            className="h-6 w-6 filter grayscale brightness-0 opacity-60 transition"
          />
        </button>
      </div>

    </div>
  );
};


export default HeaderBar;
